<template>
  <b-modal scrollable id="ssoi-setting-modal" size="xl" title="Select SSOI ID" @show="getList" @hidden="onHidden">
    <div class="mb-3 ml-auto" style="width: 30%">
      <b-input-group>
        <template #append>
          <b-button variant="primary" @click="getList">
            <b-icon icon="search" aria-hidden="true"></b-icon>
          </b-button>
        </template>
        <b-form-input v-model="search" placeholder="Search SSOI" @keyup.enter="getList"></b-form-input>
      </b-input-group>
    </div>
    <TheTable
      :records="records"
      :fields="tableFields"
      :loading="loading"
      selectable
      @row-selected="onTableSelect"
      select-mode="single"
    >
      <template #cell(checkbox)="{ item }">
        <b-form-radio v-model="selectedId" :value="item" />
      </template>
    </TheTable>
    <template #modal-footer>
      <div class="d-flex w-100">
        <div class="d-flex align-items-center ml-2">
          <label class="mr-2 mt-1">Entries</label>
          <b-form-select :value="perPage" :options="[10, 25, 50, 100]" @change="handleEntries" style="width: auto">
          </b-form-select>
        </div>
        <b-pagination
          :value="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          @change="handlePagination"
          class="mb-0"
        >
        </b-pagination>

        <b-button variant="primary" @click="onSubmit">Submit</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { debounce } from 'lodash'

export default {
  props: {
    accountType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableFields: [
        {
          key: 'checkbox',
          label: '',
          type: 'text',
          size: '50px',
        },
        {
          key: 'description_line',
          label: 'Description',
          size: '200px',
        },
        {
          key: 'type',
          label: 'Type',
          size: '50px',
        },
        {
          key: 'ssoi_id',
          label: 'SSOI ID',
          size: '50px',
          tdClass: 'font-weight-bold',
        },
      ],
      records: [],
      currentPage: 1,
      perPage: 50,
      rows: 0,
      loading: false,
      selectedId: undefined,
      search: '',
    }
  },
  watch: {
    search() {
      this.searchList()
    },
  },
  methods: {
    getList() {
      this.loading = true
      const params = {
        params: {
          pagination: { page: this.currentPage, pageSize: this.perPage },
          filters: {
            type: this.accountType,
            ssoi_id: {
              $contains: this.search,
            },
          },
        },
      }

      this.$api
        .get('/ssoi-settings', params)
        .then((res) => {
          this.records = res.data.data
          const { page, pageCount, pageSize, total } = res.data.pagination
          this.currentPage = page
          this.rows = total
        })
        .catch((err) => {
          this.$showError(err.response?.data?.error?.message || 'Unable to fetch api records')
        })
        .finally(() => {
          this.loading = false
        })
    },
    searchList: debounce(function () {
      this.getList()
    }, 900),
    handlePagination(currentPage) {
      this.currentPage = currentPage
      this.getList()
    },
    handleEntries(value) {
      this.currentPage = 1
      this.perPage = value
      this.perPage = value
    },
    onTableSelect(items) {
      this.selectedId = items[0]
    },
    onSubmit() {
      if (this.selectedId) {
        this.$emit('onSelect', this.selectedId)
        this.$bvModal.hide('ssoi-setting-modal')
      }
    },
    onHidden() {
      this.selectedId = undefined
    },
  },
}
</script>
